import AppsIcon from '@mui/icons-material/Apps';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { Drawer, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useMemo, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { isSubAdmin } from '../../services/auth-service';
import { NewAdminPages, getAccess, hasAnyHistoricReportAccess, hasAnyLiveReportAccess } from '../../services/page-service';
import { ReactComponent as AdminIcon } from '../../static/icons/admin.svg';
import { ReactComponent as CommandCenterIcon } from "../../static/icons/agent.svg";
import { ReactComponent as CampaignsIcon } from '../../static/icons/campaign.svg';
import { ReactComponent as DashboardIcon } from '../../static/icons/dashboard.svg';
import { ReactComponent as DataManagementIcon } from '../../static/icons/dataManagement.svg';
import { ReactComponent as ReportIcon } from '../../static/icons/report.svg';
import { ReactComponent as TemplatesIcon } from '../../static/icons/template.svg';
import { checkRoles, checkSettings } from '../../utils/util';
import AppsMenu from '../admin/menu/AppsMenu';
import AdminMenu from '../admin/menu/Menu';
import AgentToolbarIframe from '../AgentToolbarIframe/AgentToolbarIframe';
import '../OZSidenav/OZSidenav.css';
import ReportsDrawer from '../ReportsDrawer/ReportsDrawer';

const drawerWidth = 90;

const useStyles: any = makeStyles((theme: Theme) => ({
	drawer: {
		width: drawerWidth,
		flexShrink: 0
	},
	drawerPaper: {
		padding: theme.spacing(1),
		width: drawerWidth,
		borderRight: '1px solid #E6E5E6',
		background: 'white'
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	},
	toolbar: {
		marginTop: 95
	}
}));

function OZSidenav() {
	// const [isReportsOpen, setIsReportsOpen] = useState<boolean>(false);
	const [currentRoute, setCurrentRoute] = useState<string>('');
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [isReportsOpen, setIsReportsOpen] = useState<null | HTMLElement>(null);
	const [isAppsOpen, setIsAppsOpen] = useState<null | HTMLElement>(null);
	const [subUserAgentMapping, setSubUserAgentMapping] = useState<boolean>(false);
	const [agentToolbarUrl, setAgentToolbarUrl] = useState<string>('');
	const [isAgentToolbarOpen, setIsAgentToolbarOpen] = useState<boolean>(false);
	const subAdmin = useMemo(() => isSubAdmin(), []);
	const showCommandCenter = checkRoles("ROLE_SLASHCALL");

	async function isSubUserAgentMapping() {
		try {
			const resp = await checkSettings("USER_AGENT_MAPPING")
			if (resp && (resp === true || resp === "true")) {
				setSubUserAgentMapping(true)
			}
		} catch (error) {
			setSubUserAgentMapping(false)
			console.log("error in isSubUserAgentMapping", error)
		}
	}

	useEffect(() => {
		isSubUserAgentMapping()
	}, [subAdmin])

	const classes = useStyles();
	const location = useLocation();
	const navigate = useNavigate();

	const handleClick = (event: React.MouseEvent<HTMLElement>, name: any) => {
		if (name === 'Admin') {
			setAnchorEl(event.currentTarget);
		}
		if (name === 'Reports') {
			// setIsReportsOpen(!isReportsOpen)
			setIsReportsOpen(event.currentTarget);
		}
		if (name === 'Apps') {
			setIsAppsOpen(event.currentTarget);
		}
	};

	const handleMouseLeave = (event: React.MouseEvent<HTMLElement>, name: any) => {
		if (name !== 'Admin') {
			setAnchorEl(null);
		}
		if (name !== 'Reports') {
			setIsReportsOpen(null)
		}
	}

	const handleClose = () => {
		setAnchorEl(null);
		// setIsReportsOpen(false)
		setIsReportsOpen(null)
		setIsAppsOpen(null);
	};

	const handleReportsDrawer: any = (boolValue: boolean) => {
		// setIsReportsOpen(boolValue);
		setIsReportsOpen(null);
	};

	const handleAppsClose = () => {
		setIsAppsOpen(null);
	};

	const handleAgentToolbarClick = (url: string) => {
		setAgentToolbarUrl(url);
		setIsAgentToolbarOpen(true);
	};

	const handleAgentToolbarClose = () => {
		setIsAgentToolbarOpen(false);
		setAgentToolbarUrl('');
	};

	const listItems: any = [
		...(showCommandCenter ? [{ name: 'Command Center', icon: CommandCenterIcon, route: '/command-center', routeActive: 'command-center' }] : []),
		{ name: 'Dashboard', icon: DashboardIcon, route: '/preset', routeActive: showCommandCenter ? 'preset' : '' },
		{ name: 'Reports', icon: ReportIcon, handler: handleReportsDrawer, routeActive: 'reports' },
		{ name: 'Campaigns', icon: CampaignsIcon, route: '/admin/campaigns', routeActive: 'campaigns' },
		{ name: 'Templates', icon: TemplatesIcon, route: '/admin/templates', routeActive: 'templates' },
		{ name: 'Admin', icon: AdminIcon, handler: handleClose, routeActive: 'admin' },
		{ name: 'CXI Reach', icon: SendRoundedIcon, route: '/admin/cxhubReach', routeActive: 'cxhubReach' },
		{ name: 'Data Management', icon: DataManagementIcon, route: '/data-management', routeActive: 'data-management' },
		...(subUserAgentMapping ? [{ name: 'Apps', icon: AppsIcon, handler: handleAppsClose, routeActive: 'apps' }] : [])
	];
	let filteredListItems: any = listItems.filter((component: any, index: any) => {
		if (component.name === "Templates") {
			// return (setTimeout(authPage(AdminPages.TEMPLATES_VIEW)), 1000);
			return (localStorage.getItem('newAuthPage')?.includes(NewAdminPages.TEMPLATES_PAGE) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.TEMPLATES_PAGE}_${getAccess('viewAccess')}`) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.TEMPLATES_PAGE}_${getAccess('fullAccess')}`) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.TEMPLATES_PAGE}_${getAccess('editAccess')}`));
		}
		else if (component.name === "Campaigns") {
			// return authPageWithDelay(NewAdminPages.CAMPAIGN_PAGE);
			return (localStorage.getItem('newAuthPage')?.includes(NewAdminPages.CAMPAIGN_PAGE) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.CAMPAIGN_PAGE}_${getAccess('viewAccess')}`) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.CAMPAIGN_PAGE}_${getAccess('fullAccess')}`) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.CAMPAIGN_PAGE}_${getAccess('editAccess')}`) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.CAMPAIGN_PAGE}_${getAccess('dataUpload')}`));
		}
		else if (component.name === "Reports") {
			// return (localStorage.getItem('newAuthPage')?.includes(NewAdminPages.REPORTS) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.REPORTS}_${getAccess(false)}`));
			return (hasAnyLiveReportAccess() || hasAnyHistoricReportAccess());
			// return (localStorage.getItem('newAuthPage')?.includes(NewAdminPages.LIVE_REPORTS) || localStorage.getItem('newAuthPage')?.includes(NewAdminPages.HISTORIC_REPORTS) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.LIVE_REPORTS}_${getAccess(true)}`) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.HISTORIC_REPORTS}_${getAccess(true)}`));
		}
		else if (component.name === "Dashboard") {
			return (localStorage.getItem('newAuthPage')?.includes(NewAdminPages.DASHBOARDS) || localStorage.getItem('newAuthSubAdminAccess')?.includes(`${NewAdminPages.DASHBOARDS}_${getAccess(true)}`));
		}
		else if (component.name === "CXI Reach") {
			return (checkRoles("ROLE_CXI"))
		}
		else if (component.name === "Data Management") {
			return (checkRoles("ROLE_RULE_ENGINE"));
		}
		else if (component.name === "Apps") {
			return subUserAgentMapping;
		}
		else {
			return true
		}
	})

	const isActive = (route: string) => {
		if (route.length) {
			if (route === 'admin') {
				return currentRoute.includes('admin') && (!currentRoute.includes('templates') && !currentRoute.includes('campaigns') && !currentRoute.includes('cxhubReach'))
			} else {
				return currentRoute.includes(route);
			}

		}
		else {
			return !currentRoute.includes('reports') && !currentRoute.includes('admin') && !currentRoute.includes('data-management')
		}
	};

	useEffect(() => {
		if (location.pathname) {
			setCurrentRoute(location.pathname);
		}
	}, [location]);

	const navigateTo = (route: any) => {
		if (currentRoute.includes('campaigns') && isActive(route)) {
			navigate('/admin/');
			navigate(-1);
		}
	}
	return (
		<Drawer
			className={classes.drawer}
			variant="permanent"
			classes={{
				paper: classes.drawerPaper
			}}
		>
			<div className={classes.toolbar} />
			<div>
				{
					filteredListItems.map((item: any, index: any) => {
						const IconComponent = item.icon || null;
						return (
							<div key={item.name} onClick={() => {
								// localStorage.clear(); 
								navigateTo(item.routeActive)
							}}
							// onMouseEnter={(e) => handleMouseLeave(e, item.name)}
							>
								<NavLink to={item.handler ? '#' : item.route}
									onClick={(e) => handleClick(e, item.name)}
									// onMouseEnter={(e) => handleClick(e, item.name)}
									aria-controls={Boolean(anchorEl) ? 'adminMenu' : undefined}
									aria-haspopup="true"
									aria-expanded={Boolean(anchorEl) ? 'true' : undefined}>
									<div className={`listItem ${isActive(item.routeActive) ? 'active' : ''}`} onClick={item.handler ? item.handler : null}>
										<>
											<IconComponent />
											<p className="noMargin listItemText">{item.name}</p>
										</>
									</div>
								</NavLink>
							</div>
						);
					})}
			</div>
			<ReportsDrawer isOpen={isReportsOpen} handleReportsDrawer={handleReportsDrawer}></ReportsDrawer>
			<AdminMenu anchorEl={anchorEl} handleClose={handleClose} />
			{subUserAgentMapping && <AppsMenu
				anchorEl={isAppsOpen}
				handleClose={handleAppsClose}
				onAgentToolbarClick={handleAgentToolbarClick}
				subAdmin={subAdmin}
			/>}
			{isAgentToolbarOpen && subAdmin && <AgentToolbarIframe
				url={agentToolbarUrl}
				onClose={handleAgentToolbarClose}
			/>}
		</Drawer>
	);
}

export default OZSidenav;
